import { render, staticRenderFns } from "./MemberQuestion.vue?vue&type=template&id=6a4f8a6e&scoped=true&"
import script from "./MemberQuestion.vue?vue&type=script&lang=js&"
export * from "./MemberQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MemberQuestion.vue?vue&type=style&index=0&id=6a4f8a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f8a6e",
  null
  
)

export default component.exports